import React, {useRef, useState} from 'react';
import PropTypes from 'prop-types';
import UpdateTaskMutation from '../../../../mutations/update_task_mutation.modern';
import {PercentageInput} from '../../../inputs/PercentageInput';
import Util from '../../../../forecast-app/shared/util/util';

const ProgressTile = ({intl, task}) => {
	const [expanded, setExpanded] = useState(false);
	const inputRef = useRef(null);

	const onClick = e => {
		setExpanded(!expanded);
	};

	const onBlur = e => {
		setExpanded(false);
	};

	const onKeyPress = e => {
		if (e.key === 'Enter' && document.activeElement && !e.target.className.includes('input-value')) {
			if (inputRef.current) {
				inputRef.current.focus();
			}
		}
	};

	return (
		<div
			className={'header-tile progress-tile' + (expanded ? ' expanded' : '')}
			onClick={onClick}
			onBlur={onBlur}
			onKeyPress={onKeyPress}
		>
			<div className="tile-wrapper">
				<div className="tile-container">
					<div className="tile-label">{intl.formatMessage({id: 'common.completion'})}</div>
					<div className="text-container">
						<PercentageInput
							intl={intl}
							value={Util.getSimpleProgressPerentageFromTask(task)}
							innerRef={inputRef}
							customClassName={'percentage-input'}
							mutation={value => Util.updateTaskRemaning(value, task, UpdateTaskMutation)}
							onClick={e => e.focus()}
							taskModalStyle
						/>
					</div>
				</div>
			</div>
		</div>
	);
};

ProgressTile.propTypes = {
	viewer: PropTypes.object.isRequired,
	intl: PropTypes.object.isRequired,
	task: PropTypes.object.isRequired,
	project: PropTypes.object.isRequired,
};

export {ProgressTile};
